import styled from '@emotion/styled'

import { Link, Small, spacing, typography } from 'main/ui'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`

export const QspPopoverContainer = styled.div`
  display: inline-block;
  margin-left: ${spacing.minorScale(1)}px;
  vertical-align: text-bottom;
`

export const SmallStrong = styled(Small)`
  font-weight: ${typography.fontWeight.bold};
`

export const SmallStrongLink = styled(Link)`
  font-size: ${typography.fontSize.hint};
  font-weight: ${typography.fontWeight.bold};
  line-height: 20px;
`

export const WarningIconContainer = styled.div`
  padding: ${spacing.minorScale(1)}px ${spacing.majorScale(2)}px 0 0;
  width: 20px;
`

export const WarningInfoContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`
